function baseTimes(n, iteratee) {
  for (var index = -1, result = Array(n); ++index < n; )
    result[index] = iteratee(index);
  return result;
}
export {
  baseTimes as default
};
//# sourceMappingURL=_baseTimes.js.map
